import { loader } from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('orderpage', '#order');
loader('navbar', '.header');
loader('menu', '.menu');
loader('slider', '.slider');
loader('upload', '.upload');
loader('faq');
loader('desktop-dropdown', '.header__dropdown-btn');
loader('switch', '.switch');
loader('popup', '.popup');
loader('progress-bar', '.progress-bar');
loader('video-popup', '.video-tool');
loader('postcode-check', '.postcode-form', true);
